import { useDroppable } from '@dnd-kit/core';
import frameWidth from './utils';
import useStore from './useStore';
import { txt } from '../../../services/translation';

export default function Droppable({children}){

    const { setNodeRef } = useDroppable({ id: 'certificate-droppable' });

    const {orientation, picture} = useStore();

    const width = frameWidth();

    const ratio = orientation === 'L' ? (210 / 297) : (297 / 210); // A4

    const height = Math.round(width * ratio);

    const style = {
        width: width,
        height: height,
        backgroundImage: picture?.url ? `url("${picture?.url}")` : undefined,
        backgroundColor: 'rgb(235,235,235)',
        backgroundSize: `${width}px auto`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        fontFamily: 'sans-serif',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };

    const placeholderStyle = {
        textAlign: 'center',
        fontSize: width * 0.04,
        opacity: 0.3,
        display: picture?.url ? 'none' : 'block'
    }

    return <div ref={setNodeRef} style={style}>

        {children}

        <span style={placeholderStyle}>
            {txt('dropBackgroundImage')}
            <br/>
            {txt('a4FormatInfo')}
            <br/>
            {txt('positionVariables')}
        </span>

    </div>;
}
